
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^5(76|85)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
